module.exports = "<md-card >\n        <img src=\"../../assets/image/coming.gif\" style=\"width: 100%;\"/>\n       </md-card>\n       "


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/community/community.component.html
// module id = ../../../../../src/app/community/community.component.html
// module chunks = main